import {FieldError} from 'react-hook-form';

export function useGenerativePlayground() {
  const responseFeedbacks = {
    sendToPlayground: {
      title: 'Enviar para o playground',
      error: {
        message: 'Ocorreu um erro ao processar as redações',
      },
      success: {
        message: 'As redações foram processadas',
      },
    },
    default: {
      title: 'Requisição',
      error: {
        message: 'Erro',
      },
      success: {
        message: 'Sucesso',
      },
    },
  };

  function getFormFieldError(
    errorType: FieldError['type'] | undefined,
  ): string | undefined {
    if (errorType === 'required') {
      return 'Esse campo não pode ficar em branco';
    }

    return;
  }

  return {
    responseFeedbacks,
    getFormFieldError,
  };
}
